import { Outlet, useLocation, useNavigate } from "react-router-dom";
import { Sidebar } from "../components/Sidebar";
import { UsageBanner } from "../components/UsageBanner";
import { OPSBELT_APP_URL } from "../lib/env";
import { useMe } from "../lib/hooks";
import { signOut } from "../lib/auth";

const TITLES: Record<string, string> = {
  "/": "Overview",
  "/connectors": "Connectors",
  "/destinations": "Destinations",
  "/keys": "Upload keys",
  "/audit": "Audit log",
  "/billing": "Billing",
};

// Authenticated shell — matches the OpsBelt/BlobShip admin comp: 248px sidebar,
// 60px topbar, 1080px content column. Dark canonical.
export function Layout() {
  const { data: me } = useMe();
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const title = TITLES[pathname] ?? "BlobShip";

  async function handleSignOut() {
    await signOut();
    navigate("/login", { replace: true });
  }

  return (
    <div className="flex h-full bg-surface-50 text-ink">
      <Sidebar me={me} onSignOut={handleSignOut} />
      <div className="flex min-w-0 flex-1 flex-col">
        <header className="sticky top-0 z-20 flex h-[60px] shrink-0 items-center gap-4 border-b border-surface-200 bg-surface-50/80 px-6 backdrop-blur">
          <div className="text-[15px] font-semibold tracking-tight">{title}</div>
          <a
            href={OPSBELT_APP_URL}
            target="_blank"
            rel="noopener noreferrer"
            title="OpsBelt admin — all your tools"
            className="ml-auto flex h-[38px] w-[38px] items-center justify-center rounded-[9px] border border-surface-200 bg-surface-0 text-ink-muted transition-colors hover:border-surface-300 hover:text-ink"
          >
            <svg viewBox="0 0 24 24" width="18" height="18" fill="currentColor">
              <circle cx="5" cy="5" r="2" /><circle cx="12" cy="5" r="2" /><circle cx="19" cy="5" r="2" />
              <circle cx="5" cy="12" r="2" /><circle cx="12" cy="12" r="2" /><circle cx="19" cy="12" r="2" />
              <circle cx="5" cy="19" r="2" /><circle cx="12" cy="19" r="2" /><circle cx="19" cy="19" r="2" />
            </svg>
          </a>
        </header>
        <main className="flex-1 overflow-y-auto p-8">
          <div className="mx-auto max-w-[1080px]">
            <UsageBanner />
            <Outlet />
          </div>
        </main>
      </div>
    </div>
  );
}
